import * as React from 'react';

import { useEffect, useState } from 'react';

import { Container, Flashbar, Header, KeyValuePairs, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { getGlossary } from 'src/api/catalog';
import { TABLE_CONTENT_TYPE } from 'src/commons/constants';

import { PageHeader } from 'src/components/common/PageHeader';
import { GOVERNANCE_TAG_TYPE, glossaryTypeDisplayName } from 'src/components/metadata/constants';

export interface ViewBusinessGlossaryProps {
  setContentType: any;
  location: any;
  match: any;
  activeGroup: string;
  activeWorkspace: any;
}

const ViewBusinessGlossary = (props: ViewBusinessGlossaryProps) => {
  const [businessGlossary, setBusinessGlossary] = useState(undefined);
  const [notifications, setNotifications] = useState([]);
  const [glossaryId, setGlossaryId] = useState(undefined);
  const [glossaryOwnerId, setGlossaryOwnerId] = useState(undefined);
  const [glossarySubTypeName, setGlossarySubTypeName] = useState('');
  const [isGovernanceTag, setIsGovernanceTag] = useState(false);

  useEffect(() => {
    props.setContentType(TABLE_CONTENT_TYPE);
    setGlossaryOwnerId(props.match.params.glossaryOwnerId);
    setGlossaryId(props.match.params.id);
  }, []);

  useEffect(() => {
    if (glossaryId && glossaryOwnerId) {
      getGlossaryForGivenId();
    }
  }, [glossaryId, glossaryOwnerId]);

  const getGlossaryForGivenId = async () => {
    try {
      let getGlossaryResult = await getGlossary({
        GlossaryId: glossaryId,
        OwnerId: glossaryOwnerId,
      });
      setBusinessGlossary(getGlossaryResult.GlossaryDetails);
      setGlossarySubTypeName(glossaryTypeDisplayName.get(getGlossaryResult.GlossaryDetails.GlossarySubType));
      setIsGovernanceTag(GOVERNANCE_TAG_TYPE === getGlossaryResult.GlossaryDetails.GlossarySubType);
    } catch (err) {
      setNotification('error', err.message);
    }
  };

  const buttonOptions = () => {
    return [
      {
        text: '',
        icon: 'refresh',
        onItemClick: getGlossaryForGivenId,
      },
    ];
  };

  const setNotification = async (header, message) => {
    if (header === 'success') {
      setNotifications([
        {
          type: 'success',
          content: message,
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    } else {
      setNotifications([
        {
          header: header,
          type: 'error',
          content: message,
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    }
  };

  const viewableKeyValuePairs = () => {
    const pairs = [
      {
        label: 'Owner',
        value: businessGlossary?.OwnerId,
      },
      {
        label: 'Name',
        value: businessGlossary?.Name,
      },
      {
        label: isGovernanceTag ? 'Governance tag name' : 'Value',
        value: businessGlossary?.GlossaryValue,
      },
      {
        label: 'Description',
        value: businessGlossary?.Description,
      },
      {
        label: 'Status',
        value: businessGlossary?.Status,
      },
      {
        label: 'Visibility',
        value: businessGlossary?.Visibility,
      },
      {
        label: 'Type',
        value: businessGlossary?.GlossaryType.replace('Glossary#', ''),
      },
    ];
    if (isGovernanceTag) {
      // remove the Name of the business glossary - Fixed for governance tags
      pairs.splice(1, 1);
    }
    return pairs;
  };

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <Flashbar items={notifications} />
      <PageHeader buttons={buttonOptions()} header={`${glossarySubTypeName} ID: ${glossaryId}`} />
      <Container header={<Header variant={'h2'}>{glossarySubTypeName} details</Header>}>
        <KeyValuePairs columns={3} items={viewableKeyValuePairs()} />
      </Container>
    </SpaceBetween>
  );
};

export default ViewBusinessGlossary;
